import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignWellRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#4db7c4",
		d: "M15 4a11.2 11.2 0 1 1 .5 22.3A11.2 11.2 0 0 1 15 4"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fefefe",
		d: "M17.2 7.2a4 4 0 0 1 1.8.3q.8.3 1 1.1a3 3 0 0 1 0 2q-.4 1-1.2 1.3c-.3.1-1.2.3-1.3 0q.1-.5.4-.7c.7-.6 1.5-1.7.5-2.5q-.9-.4-1.8-.1a5 5 0 0 0-3 2.1q-.7 1.2-.2 2.3.3.7.9 1.1l1.4 1.3c1.4 1.1 3.3 2.3 2.8 4.5l-.5 1a5 5 0 0 1-2.4 2l-1 .2c-1.5.3-3.4 0-4-1.6-.5-1-.2-2.4 1-3h.7q.3.5.1.9c-1 1.7 0 2.5 1.8 2.3 1.3-.1 2.8-1 2.7-2.6-.1-1-1.2-1.7-1.9-2.3-1.3-1.2-3.3-2.2-3.5-4.2q0-1.1.5-2 1.7-3 5.2-3.5"
	})]
});
export default SvgSignWellRegularIcon;
